function readBooleanEnv(value: string | undefined): boolean {
  if (!value) {
    return false;
  }

  const normalized = value.trim().toLowerCase();
  return ["1", "true", "yes", "on"].includes(normalized);
}

export const paymentEmbedEnv = {
  supergasPayAutofillEnabled: readBooleanEnv(
    process.env.REACT_APP_SUPERGAS_PAY_AUTOFILL_ENABLED,
  ),
  supergasPayAutosubmitEnabled: readBooleanEnv(
    process.env.REACT_APP_SUPERGAS_PAY_AUTOSUBMIT_ENABLED,
  ),
} as const;
